<template>
    <b-modal id="modal-location" modal-class="location" ref="modal-location" hide-header hide-footer>
        <div class="d-flex justify-content-center mb-2">
            <img class="location_image" :src="$wdconfig.default.logo" :alt="$wdconfig.default.title">
        </div>
        <div class="mb-4">
            <div class="location_title text-center" v-if="$wdconfig.locations.length <= 5 && $wdconfig.modules.location.question">
                {{ $wdconfig.modules.location.question }}
            </div>
            <div class="mb-3 position-relative" v-if="$wdconfig.locations.length > 5">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="25px" height="25px" class="position-absolute" style="top: 0; left: 5px; bottom: 0; margin: auto; pointer-events: none" fill="currentColor">
                    <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"/>
                </svg>
                <input type="text" class="location_input" v-model="searchTerm" :placeholder="$wdconfig.modules.location.question" style="padding-left: 35px">
            </div>
            <div class="location_box_locations">
                <div class="d-flex align-items-baseline" :class="{'justify-content-center': $wdconfig.locations.length <= 5}" v-for="location in locations" :key="location.id">
                    <a :href="location.link" target="_top" class="location_name d-flex" @click.prevent="saveLocation(location)">
                        <svg class="location_icon_map flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="17" height="25" x="0px" y="0px"
                         viewBox="0 0 512 512" style="enable-background:new 0 0 512 512; fill: currentColor" xml:space="preserve">
                            <path d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035
                                c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719
                                c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z"/>
                        </svg>
                        <span class="ml-1">{{ location.name }}</span>
                    </a>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            searchTerm: ''
        }
    },
    mounted() {
        const hasSelectedLocation = Cookies.get('location_selected') === 'true'
        const cameFromRedirect = this.$route.query.origin === 'location'

        if (cameFromRedirect && !hasSelectedLocation) {
            Cookies.set('location_selected', 'true', { expires: 7 })
            return
        }

        setTimeout(() => {
            if (this.$wdconfig.locations.length > 1 && !hasSelectedLocation) {
                this.$refs['modal-location'].show()
            }
        }, 2000)
    },
    computed: {
        locations: function () {
            const searchTerm = this.searchTerm.trim().toLowerCase()
            return this.$wdconfig.locations.filter(location =>
                location.name.toLowerCase().includes(searchTerm)
            )
        }
    },
    methods: {
        saveLocation(location) {
            try {
                const targetUrl = new URL(location.link, window.location.origin)
                if (targetUrl.origin === window.location.origin) {
                    Cookies.set('location_selected', 'true', { expires: 7 })
                    this.$refs['modal-location'].hide()
                    return
                }
                targetUrl.searchParams.set('origin', 'location')
                window.location.href = targetUrl.toString()
            } catch (e) {
                console.error('URL inválida:', e)
            }
        }
    }
}
</script>
